"use client";

import { startTransition, useLayoutEffect, useState } from "react";

export const useIsPageOnTop = (enabled: boolean = false) => {
  const [isPageOnTop, setIsPageOnTop] = useState(true);

  useLayoutEffect(() => {
    if (enabled) {
      startTransition(() => {
        setIsPageOnTop(window.scrollY === 0);
      });

      const onScroll = () => {
        setIsPageOnTop(window.scrollY === 0);
      };
      window.addEventListener("scroll", onScroll, {
        passive: true,
      });

      return () => {
        window.removeEventListener("scroll", onScroll);
      };
    }
  }, [enabled]);

  return isPageOnTop;
};
